import { OPEN_MODAL_ITEM, CLOSE_MODAL_ITEM } from '../actions/constants';

export const defaultState = {
  showModal: false,
  modalItem: null,
};

export const mapAndTableModalsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case OPEN_MODAL_ITEM: {
      return {
        ...state,
        showModal: true,
        modalItem: action.modalItem,
      };
    }
    case CLOSE_MODAL_ITEM: {
      return {
        ...state,
        showModal: false,
        modalItem: null,
      };
    }
    default:
      return state;
  }
};
